/**
 * manager-spot-card.js
 * Gerencia o seletor de quantidade e o add-to-cart dos spot cards de produto
 * (snippets/card-product.liquid). Disponível como window.SpotCardManager.
 *
 * Dependências (devem carregar antes):
 *   - window.CartManager (manager-cart.js)
 *
 * ─── HTML esperado ──────────────────────────────────────────────────────────
 *
 *   <div data-spot-card>
 *     <button class="spot-qty-btn" data-action="minus">-</button>
 *     <input class="spot-qty-input" value="1" min="1" max="10">
 *     <button class="spot-qty-btn" data-action="plus">+</button>
 *     <button class="spot-add-btn" data-variant-id="12345678">Comprar</button>
 *   </div>
 *
 * ─── Comportamento ────────────────────────────────────────────────────────
 *
 *   - Click em .spot-qty-btn[data-action] → incrementa/decrementa .spot-qty-input
 *   - Click em .spot-add-btn → CartManager.add(variantId, { quantity, button })
 *   - Funciona com cards dinâmicos (event delegation em document)
 */

class SpotCardManager {
  constructor() {
    this._onClick = this._onClick.bind(this);
    document.addEventListener('click', this._onClick);
  }

  _onClick(e) {
    const qtyBtn = e.target.closest('.spot-qty-btn');
    if (qtyBtn) {
      this._changeQty(qtyBtn);
      return;
    }

    const addBtn = e.target.closest('.spot-add-btn');
    if (addBtn) this._addToCart(addBtn);
  }

  _changeQty(btn) {
    const container = btn.closest('[data-spot-card]');
    const input = container?.querySelector('.spot-qty-input');
    if (!input) return;

    const current = parseInt(input.value) || 1;
    const max = parseInt(input.getAttribute('max')) || 9999;

    if (btn.dataset.action === 'plus' && current < max) {
      input.value = current + 1;
    } else if (btn.dataset.action === 'minus' && current > 1) {
      input.value = current - 1;
    }
  }

  async _addToCart(btn) {
    if (btn.disabled) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const container = btn.closest('[data-spot-card]');
    const input = container?.querySelector('.spot-qty-input');
    const qty = parseInt(input?.value) || 1;

    if (window.CartManager) {
      await window.CartManager.add(variantId, { quantity: qty, button: btn });
    } else {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty }),
      });
      document.dispatchEvent(new CustomEvent('cart:added', { detail: {}, bubbles: true }));
    }
  }

  destroy() {
    document.removeEventListener('click', this._onClick);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.SpotCardManager = new SpotCardManager();
});
